export default {"src":"/login-app/[GIT_HASH]/_next/static/media/delete.0345d72d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};